// extracted by mini-css-extract-plugin
export var container = "styles-module--container--808Su";
export var roundButton = "styles-module--roundButton--Gq5--";
export var buttonContainer = "styles-module--buttonContainer--I0gNS";
export var form = "styles-module--form--4Zcxt";
export var label = "styles-module--label--C1HXA";
export var input = "styles-module--input--tBqZV";
export var textArea = "styles-module--textArea--McM3n";
export var submit = "styles-module--submit--hc227";